import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA: register a minimal service worker (network-only for /api/* and
// navigations) so Powersure is installable to home screen on Android/iOS.
// The SW intentionally does NOT cache API or checkout responses.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* silent — SW is optional; app works fully without it */
    });
  });
}
